import styled from "styled-components";
import SbButton from "uiCore/SbButton/SbButton";

// Okta SSO button — built on the uiCore SbButton (buttonType="secondary").
// Custom ghost styling (2px primary border, fixed size) + theme colors; was hardcoded teal in SSOLogin.scss.
export const OktaButtonStyled = styled(SbButton)`
  && {
    display: flex;
    align-items: center;
    justify-content: start;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 800;
    font-size: 1.1rem;
    padding: 0.5rem 2.5rem 0.5rem 1rem;
    border-radius: 2px;
    margin-bottom: 2.5rem;
    outline: none;
    min-width: 400px;
    min-height: 40px;
    height: auto;
    transition: background 0.2s, color 0.2s, border-color 0.2s;
  }

  &&:hover,
  &&:focus {
    background: ${({ theme }) => theme.colors.hoverBg};
    color: ${({ theme }) => theme.colors.primaryHover};
    border-color: ${({ theme }) => theme.colors.primaryHover};
  }
`;
